import { Skeleton } from "../ui/skeleton";

export const SectionSkeleton = () => (
  <div className="p-6 bg-card border border-border rounded-xl space-y-4">
    <Skeleton className="h-6 w-56" />
    {Array.from({ length: 5 }).map((_, i) => (
      <Skeleton key={i} className="h-16 w-full" />
    ))}
  </div>
);
export function GlobalSkeleton() {
  return (
    <div className="container mx-auto px-4 py-6 animate-pulse">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <SectionSkeleton />
        <SectionSkeleton />
        <SectionSkeleton />
        <SectionSkeleton />
      </div>
    </div>
  );
}